'use client';

import { useActionTrigger } from '@/hooks/useAction';
import { Button, ButtonProps } from '@/ui/Button';

export type CtaActionButtonProps = ButtonProps & {
    action: string;
};

export function CtaActionButton({ action, ...props }: CtaActionButtonProps) {
    const fire = useActionTrigger(action);

    function handleClick() {
        fire();
    }

    return <Button {...props} onClick={handleClick} />;
}
